import {
  BASE_URL,
  REPORTING_LOINC_DATA,
  REPORTING_LOINC,
  ERROR_MSG,
  LOINC,
  PAGE,
  API_GATEWAY_KEY,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchReportingLoincData = async (
  pageNo,
  recordsPerPage,
  urlWithParams
) => {
  let response = await fetch(
    `${BASE_URL}${REPORTING_LOINC_DATA}/${pageNo}/${recordsPerPage}?${urlWithParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchReportingLoincDatabyLoincId = async (
  loincId,
  pageNo,
  recordsPerPage
) => {
  let response = await fetch(
    `${BASE_URL}${REPORTING_LOINC}${LOINC}/${loincId}${PAGE}/${pageNo}/${recordsPerPage}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const removeReportingLoincRecord = async (reportingLoincId) => {
  let response = await fetch(
    `${BASE_URL}${REPORTING_LOINC}/${reportingLoincId}`,
    {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  if (!response.ok) {
    return ERROR_MSG;
  }
};

export const fetchReportingLoincById = async (reportingLoincId) => {
  let response = await fetch(
    `${BASE_URL}${REPORTING_LOINC}/${reportingLoincId}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const addNewReportingLOINC = async (form) => {
  let response = await fetch(`${BASE_URL}${REPORTING_LOINC}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    return ERROR_MSG;
  }
};

export const updateReportingLOINCData = async (form) => {
  let response = await fetch(`${BASE_URL}${REPORTING_LOINC}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    return ERROR_MSG;
  }
};
